import { useContext, useState, useEffect } from "react"
import { UserContext } from "../../contexts/UserContext"
import { CustomButton } from "../global/CustomButton"
import { useLocation } from "react-router-dom"
import "./paymentSection.css"

export function PaymentSection() {
    const userDataContext = useContext(UserContext)
    const { token, dispatch } = userDataContext
    
    const [checkoutCart, setCheckoutCart] = useState(null)
    const [paymentMethod, setPaymentMethod] = useState("Online Payment")
    const [subtotal, setSubtotal] = useState(null)

    const location = useLocation()
    //const subtotal = location.state.subtotal

    useEffect(() => {
        if(location.state?.fromCart) {
            setCheckoutCart(location.state.cartClone)
            setSubtotal(location.state.subtotal)
        } else {
            const user = localStorage.getItem("user")
            const userCart = JSON.parse(user).user.cart
            setCheckoutCart(userCart)

            let cartSubtotal = 0
            userCart.map(e => cartSubtotal += e.salePrice)
            setSubtotal(cartSubtotal)
        }
    }, [])

    async function handlePlaceOrder() {
        const orderId = crypto.randomUUID().split("-")[0]
        //${process.env.REACT_APP_API_BASE_URL}
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/placeOrder`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
                orderId, paymentMethod, products: checkoutCart, totalAmount: subtotal
            })
        })
        const json = await response.json()

        if(response.ok) {
            console.log(json)
            const { user, order } = json
            dispatch({ type: "PLACE_ORDER", payload: order })
            localStorage.setItem("user", JSON.stringify({ user, token }))
        }
    }
    //${process.env.REACT_APP_API_BASE_URL}
    async function handleStripe() {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/stripeCheckout`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "authorization": `Bearer ${token}`
            },
            body: JSON.stringify({ items: checkoutCart })
        })
        const json = await response.json()

        if(response.status === 200) {
            window.location = json.url
        } else {
            console.log(json)
        }
    }

    return (
        <div className="payment-section border rounded-2 ">
            <div className="d-flex gap-3">
                <div className="d-flex flex-column gap-4">
                    {
                        checkoutCart && checkoutCart.map(e => (
                            <img key={e.customId} src={e.image} height={50} className="m-auto" alt="" />
                        ))
                    }
                </div>
                <div className="d-flex flex-column gap-4">
                    {
                        checkoutCart && checkoutCart.map(e => (
                            <div key={e.customId} className="checkout-item-title align-items-center">
                                {e.title}
                            </div>
                        ))
                    }
                </div>
                <div className="d-flex flex-column ms-auto gap-4">
                    {
                        checkoutCart && checkoutCart.map(e => (
                            <div key={e.customId} className="checkout-item-price d-flex align-items-center justify-content-end">
                                ${e.salePrice ? e.salePrice : e.regularPrice}
                            </div>
                        ))
                    }
                </div>
            </div>

            <div className="mt-5">
                <div className="d-flex justify-content-between">
                    <div>Subtotal</div>
                    <div>${subtotal}</div>
                </div>
                
                <hr />
            </div>
            
            <div className="mt-3">
                <div className="d-flex justify-content-between">
                    <div>Shipping</div>
                    <div>Free</div>
                </div>
                
                <hr />
            </div>

            <div className="d-flex justify-content-between mt-3">
                <div>Total</div>
                <div>${subtotal}</div>
            </div>

            <div className="d-flex justify-content-between mt-5">
                <div>
                    <label className="custom-radio" onClick={() => setPaymentMethod("Online Payment")}>
                        <input type="radio" defaultChecked="checked" name="radio" />
                        <span className="checkmark"></span>
                        <div className="fs-6">Bank</div>
                    </label>
                </div>
                
                <div className="d-flex gap-2 pay-icons">
                    <div className="paypal-icon"></div>
                    <div className="visa-icon"></div>
                    <div className="mastercard-icon"></div>
                </div>
            </div>
            
            <div className="mt-2">
                <label className="custom-radio" onClick={() => setPaymentMethod("COD")}>
                    <input type="radio" name="radio" />
                    <span className="checkmark"></span>
                    <div className="fs-6">Cash on Delivery</div>
                </label>
            </div>

            <div className="d-flex align-items-center gap-3 coupon-code mt-4">
                <input type="text" placeholder="Coupon Code" />
            </div>

            <div className="d-flex gap-2 pay-btns mt-2">
                <div className="w-50">
                    <CustomButton
                        color="primary"
                        text="Apply Coupon"
                    />
                </div>
                <div className="w-50">
                    <CustomButton
                        color="primary"
                        text="Place Order"
                        btnFunction={handlePlaceOrder}
                    />
                </div>  
            </div>

            <div className="d-flex cntr rounded-1 gap-4 mt-2 stripe-btn"
                onClick={handleStripe}>
                <div className="stripe-logo"></div>
                Pay with Stripe
            </div>
            
        </div>
    )
}